import { render } from "./Register-view.vue?vue&type=template&id=73adb2b0"
import script from "./Register-view.vue?vue&type=script&lang=js"
export * from "./Register-view.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__